module.exports = __webpack_public_path__ + "static/media/list-alt-regular.c56c579e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/list-alt-regular.svg
// module id = 209
// module chunks = 0